module.exports = __webpack_public_path__ + "img/service.30cb44f1.svg";